import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const portrait = "/thom-gallagher.jpg";

export default function AboutPage() {
    return (
        <div className="bg-brand-paper" data-testid="about-page">
            <section className="mx-auto max-w-7xl px-6 lg:px-10 pt-20 pb-24 lg:pt-28">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    className="grid lg:grid-cols-12 gap-12 items-center"
                >
                    <div className="lg:col-span-7">
                        <div className="text-xs uppercase tracking-[0.25em] text-brand-gold font-semibold mb-5">
                            — About
                        </div>
                        <h1 className="font-serif text-5xl lg:text-7xl leading-[1.05] tracking-tight text-brand-ink">
                            Meet <span className="italic">Thom Gallagher</span>
                        </h1>
                        <div className="text-sm tracking-wide text-brand-muted mt-4 uppercase">
                            30+ Years · Sales · Business · Leadership
                        </div>
                        <p className="mt-8 text-lg lg:text-xl text-brand-muted leading-relaxed max-w-xl">
                            With over 30 years of experience in sales, business,
                            and leadership across both small and large
                            organizations, Thom brings a rare depth of
                            perspective to real estate. His background spans
                            customer service, marketing, and the kind of
                            negotiation skills that come only from decades of
                            practice — and he still approaches every business
                            relationship with the same energy and care he
                            started with.
                        </p>
                    </div>
                    <div className="lg:col-span-5 image-zoom h-[480px] lg:h-[600px]">
                        <img
                            src={portrait}
                            alt="Thom Gallagher"
                            className="w-full h-full object-cover object-top"
                        />
                    </div>
                </motion.div>
            </section>

            <section className="bg-brand-sand">
                <div className="mx-auto max-w-4xl px-6 lg:px-10 py-24 lg:py-32 space-y-10">
                    {[
                        {
                            heading: "How Thom approaches your next move",
                            body:
                                "Thom's goal is simple: help you make informed, confident decisions, whether you're buying your first home, growing an investment portfolio, or planning your next move. He listens first, explains clearly, and works to make sure you understand every option in front of you.",
                        },
                        {
                            heading: "Credentials",
                            body:
                                "Thom holds an MBA in Executive Leadership from Royal Roads University, bringing a strategic, big-picture lens to every transaction he's part of.",
                        },
                    ].map((block, i) => (
                        <motion.div
                            key={i}
                            initial={{ opacity: 0, y: 24 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-80px" }}
                            transition={{ duration: 0.6, delay: i * 0.1 }}
                            className="border-t border-brand-line pt-8"
                        >
                            <h2 className="font-serif text-3xl lg:text-4xl text-brand-ink mb-4">
                                {block.heading}
                            </h2>
                            <p className="text-brand-muted text-lg leading-relaxed">
                                {block.body}
                            </p>
                        </motion.div>
                    ))}

                    <motion.div
                        initial={{ opacity: 0, y: 24 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{ duration: 0.6, delay: 0.2 }}
                        className="border-t border-brand-line pt-8"
                    >
                        <p className="text-brand-ink text-xl lg:text-2xl font-serif italic leading-relaxed mb-8">
                            Ready to talk through your next move? Click Get
                            Matched to get started.
                        </p>
                        <Link
                            to="/get-started"
                            data-testid="about-cta-button"
                            className="inline-flex items-center gap-3 bg-brand-ink text-brand-paper px-8 py-4 text-sm tracking-wide hover:bg-black transition-all hover:gap-4"
                        >
                            Get Matched Now!
                            <span aria-hidden>→</span>
                        </Link>
                    </motion.div>
                </div>
            </section>
        </div>
    );
}
